import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
}

const SEO: React.FC<SEOProps> = ({ 
  title = 'AI工具箱 - 免费在线工具集合',
  description = 'AI工具箱 - 免费在线工具集合，包含图片转PDF、IP查询、JSON/XML格式化、图片格式转换、Favicon制作等实用工具，无需注册，即开即用。',
  keywords = 'AI工具,在线工具,图片转PDF,IP查询,JSON格式化,XML格式化,图片转换,Favicon制作,免费工具',
  canonical
}) => {
  const fullTitle = title.includes('AI工具箱') ? title : `${title} - AI工具箱`;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;